<div class="row p-3" *ngIf="case!=null" style="background-color: #D6D3C4;;">
    <div class="col-5"><img width="10%"  [src]="case!=null? case.urlImage:''"/><span style="font-size: large; font-weight: bold;">{{case!=null?case.name:""}}</span></div>
</div>

